'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import UISelect from 'UIComponents/input/UISelect';
import { fetch as fetchCategories } from 'DesignData/api/Categories';
export default class CategoriesSelect extends Component {
  constructor(...args) {
    super(...args);

    this.onChange = e => {
      this.props.onChange(e.target.value);
    };
  }

  loadOptions(input, callback) {
    fetchCategories().then(response => {
      const {
        results
      } = response;
      callback(null, {
        options: results.map(category => {
          return {
            text: category.displayName,
            value: category.name
          };
        })
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }

  render() {
    const {
      isReadOnly,
      selectedCategories
    } = this.props;
    return /*#__PURE__*/_jsx(UISelect, {
      anchorType: "button",
      disabled: isReadOnly,
      loadOptions: this.loadOptions,
      multi: true,
      onChange: this.onChange,
      value: selectedCategories
    });
  }

}
CategoriesSelect.propTypes = {
  isReadOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  selectedCategories: PropTypes.arrayOf(PropTypes.string)
};
CategoriesSelect.defaultProps = {
  selectedCategories: []
};